enum ReturnDeclarationRoutes {
  List = '/return-declarations',
  Edit = '/return-declarations/edit/:id',
  Add = '/return-declarations/add',
}

export default ReturnDeclarationRoutes
